import '@popperjs/core/dist/umd/popper';
import Tooltip from 'bootstrap/js/dist/tooltip';

export const launchTooltip = () => {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    });
}